import React, {Component} from "react"
import {Container, Header} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization, interpolateString} from "../utils/localization";
import {connect} from "react-redux";
import Footer from "./footer";
import {checkIsVerified} from "../utils/common";
import GetHelpModal from "./getHelpModal";
import {ClickableText, CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        ...ownProps,
        name: user.firstName,
        lang: user.lang,
        initialData, benAdmin,
        user,
    }
};

class NoOENoElections extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayGetHelpModal: false,
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props);
    }

    render() {
        const {displayGetHelpModal} = this.state;
        const {initialData, lang} = this.props;
        const localization = getLocalization(lang);
        const strings = localization.noOENoElections;
        const {contractInfo: {employerName}} = initialData;

        return (
            <React.Fragment>
                <GetHelpModal localization={localization} uiFlow={initialData.uiFlow}
                              employerId={!!initialData && !!initialData.employer && initialData.employer.id}
                              displayCoveredModal={displayGetHelpModal}
                              onModalClose={() => this.setState({displayGetHelpModal: false})}
                />

                <Container className={'contentContainer'}>
                    <CustomGrid container stackable columns={1} centered fitted={'horizontally'}>
                        <CustomGrid.Column width={6}>
                            <CustomGrid stackable container style={{marginTop: '3em'}} textAlign={'left'} fitted={'horizontally'}>
                                <CustomGrid.Row columns={1}>
                                    <CustomGrid.Column>
                                        <S3Image {...IMAGE.EASY_ADMIN}/>
                                        <Header as='h1' textAlign={"center"}>{strings.note}</Header>
                                        <p>{interpolateString(strings.ended, [employerName])}
                                            <ClickableText onClick={()=>this.setState({displayGetHelpModal: true})}>
                                                {` ${strings.contact}`}
                                            </ClickableText>
                                        </p>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                            </CustomGrid>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    hideLimitationsAndExclusions={true}
                    showTopFooter={false} showCenterData={true}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(NoOENoElections));
